import powerPylonImage from "../../../../images/contents/map/powerPylon/powerPylon.svg";
import powerPylonPaleImage from "../../../../images/contents/map/powerPylon/powerPylonPale.svg";

export const configPowerPylonDh = {
  "index": {
    "Type": "JSON",
    "url": "%arinc_data_auth_api_url%/auth/power_line_default",
    "update_interval": 999999,
    "retain": true,
    "cache": true
  },
  "data": {
    "Type": "GeoJSON",
    "url": "%arinc_data_url%/power_line_default/%prefix%/%z%/%y%/%x%.json",
    "cache": true,
    "Grid": {
      "MinZoom": 4,
      "MaxZoom": 4,
      "download_max": 32,
      "BoundingBox": {
        "West": 125.0,
        "South": 26.0,
        "East": 145.0,
        "North": 46.0
      }
    }
  },
  "apiName": "auth/power_line_default"
};

export const configPowerPylonTEPCODh = {
  "index": {
    "Type": "JSON",
    "url": "%arinc_data_auth_api_url%/auth/power_line_snk_tepco",
    "update_interval": 999999,
    "retain": true,
    "cache": true
  },
  "data": {
    "Type": "GeoJSON",
    "url": "%arinc_data_url%/power_line_snk_tepco/%prefix%/%z%/%y%/%x%.json",
    "cache": true,
    "Grid": {
      "MinZoom": 4,
      "MaxZoom": 4,
      "download_max": 32,
      "BoundingBox": {
        "West": 125.0,
        "South": 26.0,
        "East": 145.0,
        "North": 46.0
      }
    }
  },
  "apiName": "auth/power_line_snk_tepco"
}

export const configPowerPylonCHUDENDh = {
  "index": {
    "Type": "JSON",
    "url": "%arinc_data_auth_api_url%/auth/power_line_snk_chubu",
    "update_interval": 999999,
    "retain": true,
    "cache": true
  },
  "data": {
    "Type": "GeoJSON",
    "url": "%arinc_data_url%/power_line_snk_chubu/%prefix%/%z%/%y%/%x%.json",
    "cache": true,
    "Grid": {
      "MinZoom": 4,
      "MaxZoom": 4,
      "download_max": 32,
      "BoundingBox": {
        "West": 125.0,
        "South": 26.0,
        "East": 145.0,
        "North": 46.0
      }
    }
  },
  "apiName": "auth/power_line_snk_chubu"
}

export const configPowerPylonLayer = {
  "Name": "PowerLine",
  "Renderer": "PowerPylon",
  "Attributes": {
    "min_zoom": 9,
    "features": [
      {
        "style": {
          "default": {
            "width": 32,
            "height": 32,
            "offsetX": -16,
            "offsetY": -16,
            "image": powerPylonImage
          },
          "dark": {
            "width": 32,
            "height": 32,
            "offsetX": -16,
            "offsetY": -16,
            "image": powerPylonPaleImage
          }
        }
      }
    ]
  }
};
